<template>
    <div class="tab-education">
        <div class="blockcont undergrad-school" v-if="highSchools.length">
            <div class="smalltitle">High School</div>
            <ul class="itemlist">
                <li v-for="highSchool in highSchools">
                    <div class="row">
                        <div class="col-xs-5">{{highSchool.name}}</div>
                        <div class="col-xs-3">{{highSchool.stateCity}}
                            <span v-if="highSchool.countryOrName">, {{highSchool.countryOrName}}</span>
                        </div>
                        <div class="col-xs-2">{{highSchool.years}}</div>
                        <div class="col-xs-2 itemaction">

                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div class="blockcont college" v-if="colleges.length">
            <div class="smalltitle">College</div>
            <ul class="itemlist">
                <li v-for="college in colleges">
                    <div class="row">
                        <div class="col-xs-5">{{college.name}}</div>
                        <div class="col-xs-3">
                            {{college.stateCity}}
                            <span v-if="college.countryOrName">, {{college.countryOrName}}</span>
                        </div>
                        <div class="col-xs-2">{{college.years}}</div>
                        <div class="col-xs-2 itemaction">

                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div class="blockcont college" v-if="others.length">
            <div class="smalltitle">Other</div>
            <ul class="itemlist">
                <li v-for="other in others">
                    <div class="row">
                        <div class="col-xs-5">{{other.name}}</div>
                        <div class="col-xs-3">{{other.stateCity}}
                            <span v-if="other.countryOrName">, {{other.countryOrName}}</span>
                        </div>
                        <div class="col-xs-2">{{other.years}}</div>
                        <div class="col-xs-2 itemaction">
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div class="blockcont college" v-if="careers.length">
            <div class="smalltitle">Career</div>
            <ul class="itemlist">
                <li v-for="career in careers">
                    <div class="row">
                        <div class="col-xs-5">{{career.companyName}}</div>
                        <div class="col-xs-3">{{career.occupation}}</div>
                        <div class="col-xs-2">{{career.years}}</div>
                        <div class="col-xs-2 itemaction">

                        </div>
                    </div>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
import CommonMixin from './../../../../mixins/general/CommonMixin.vue'
import config from '../../../../config'
import httpClient from '../../../../client'

export default {
  name: 'TabAccountSetting',
  components: {},
  props: {
    userInfo: {}
  },
  mixins: [CommonMixin],
  data () {
    return {
      highSchools: [],
      colleges: [],
      others: [],
      careers: []
    }
  },
  computed: {
    disabledForm () {
      return true
    }
  },
  watch: {},
  updated () {
  },
  mounted () {
    this.getEducation()
    this.getCareer()
  },
  beforeDestroy () {
  },
  methods: {
    async getEducation () {
      try {
        let response = await httpClient.get('/users/education/' + this.userInfo.id)
        if (response.data.s === 200) {
          let educations = response.data.data.educations
          if (educations) {
            this.highSchools = educations.filter(item => item.kind === 'highschool')
            this.colleges = educations.filter(item => item.kind === 'college')
            this.others = educations.filter(item => item.kind === 'other')
            if (this.highSchools.length) {
              this.highSchools.sort((a, b) => a.indexKey - b.indexKey)
            }
            if (this.colleges.length) {
              this.colleges.sort((a, b) => a.indexKey - b.indexKey)
            }
            if (this.others.length) {
              this.others.sort((a, b) => a.indexKey - b.indexKey)
            }
          }
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertError(e.message)
      }
    },
    async getCareer () {
      try {
        let response = await httpClient.get('/users/career/' + this.userInfo.id)
        if (response.data.s === 200) {
          this.careers = response.data.data.careers
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertError(e.message)
      }
    }
  }
}
</script>
<style scoped="">

</style>
